import { useQuery } from '@tanstack/react-query'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store.js'
import { selectItineraryUsers } from '../../../state/user.slice.js'
const globalSearchWorker = new ComlinkWorker<
    typeof import('../../../workers/globalSearch.js')
>(new URL('/src/workers/globalSearch.js', import.meta.url), {
    name: 'calculationsComlink',
    type: 'module',
})

export const useTeamSearch = (query: string) => {
    const { selectedItinerary } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItinerary: s.selectedItinerary,
            }
        })
    )
    const users = useBoundStore(selectItineraryUsers)

    const expensiveCalculationResult = useQuery({
        queryKey: ['globalSearch', selectedItinerary, query],

        queryFn: () =>
            globalSearchWorker.search(query, selectedItinerary, users),
        staleTime: Infinity,
    })
    return expensiveCalculationResult
}
